document.addEventListener('DOMContentLoaded', function () {
  const modal = document.querySelector('.hcp-modal');

  if (!modal || window.designMode === 'true') {
    return;
  }

  const overlay = modal.querySelector('.hcp-modal__overlay');
  const closeButton = modal.querySelector('.hcp-modal__close');
  const openButtons = document.querySelectorAll('[data-hcp-modal-trigger]');
  const continueBtn = modal.querySelector('[data-hcp-modal-continue]');

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  };

  const setTypeCookie = (type) => {
    const date = new Date();
    date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
    document.cookie = `aymes_user_type=${type}; expires=${date.toUTCString()}; path=/`;
  };

  const setCartAttribute = async (userType) => {
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            'user_type': userType,
          },
        }),
      });

      return response.ok;
    } catch {
      return false;
    }
  };

  const openModal = () => {
    modal.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    const firstInput = modal.querySelector('input');

    if (firstInput) {
      setTimeout(() => firstInput.focus(), 100);
    }
  };

  const closeModal = () => {
    modal.classList.remove('is-active');
    document.body.style.overflow = '';
  };

  const proceedAfterUserTypeSet = (userType, targetUrl) => {
    // Duel template is a special case where we need to refresh the page to show the correct content
    // The page is for correct but we need to ensure the header is correct for the user type
    if (window.duelTemplate === 'true') {
      // refresh the page
      window.location.reload();
      return;
    }

    if (window.patientTemplate === 'true' && userType === 'patient') {
      closeModal();
      return;
    }

    if (window.patientTemplate === 'false' && userType === 'practitioner') {
      closeModal();
      return;
    }

    window.location.href = targetUrl || '/';
  };

  const handleContinue = async (e) => {
    e.preventDefault();

    const activeInput = modal.querySelector('input[name="visitor_type"]:checked');
    if (!activeInput) return;

    const targetUrl = activeInput.getAttribute('data-url');
    const userType = activeInput.value;

    if (!(await setCartAttribute(userType))) {
      console.error('Error setting cart attribute');
      return;
    }

    setTypeCookie(userType);
    proceedAfterUserTypeSet(userType, targetUrl);
  };

  const checkUserStatus = () => {
    const userType = getCookie('aymes_user_type');

    if (!userType) {
      openModal();
    } else if (userType === 'patient' && window.patientTemplate === 'false') {
      openModal();
    } else if (userType === 'practitioner' && window.patientTemplate === 'true') {
      openModal();
    }
  };

  if (continueBtn) {
    continueBtn.addEventListener('click', handleContinue);
  }

  openButtons.forEach((btn) =>
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openModal();
    })
  );

  if (closeButton) {
    closeButton.addEventListener('click', closeModal);
  }

  /*
  if (overlay) {
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        closeModal();
      }
    });
  }*/

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-active')) {
      closeModal();
    }
  });

  checkUserStatus();
});
